export class Issue_IssueType3Model {
    public Id: number;
    public IssueTypeId: number;
    public Value: boolean;
    public IssueId: number;
    public Name: string;
}



// WEBPACK FOOTER //
// ./src/app/models/issue_issueType3Model.ts